/**
 * Converts free text (a customer name, a field name, ...) into a kebab-case segment
 * that is safe to use inside a `data-testid` value.
 */
export const toTestIdSegment = (value: string | number | null | undefined): string =>
    String(value ?? "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
